<template>
  <div class="$attrs.class">
    <label class="upper">Features</label>
    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="form-row">
          <div class="col-12 col-md-12">
            <input
              type="checkbox"
              :disabled="school.saving || crisisPhone === null"
              :checked="crisisPhone"
              @change="toggleCrisisPhone()"
            />
            <span>
              BetterMynd Crisis Phone Number
            </span>
            <p class="explainer">
              When active, will show a "Crisis Services"
              button in a student's top navigation bar that when
              clicked will display BetterMynd's crisis phone number.
              In addition, anywhere in the platform that explains BetterMynd
              is not a crisis resource, will also be replaced with the
              BetterMynd crisis phone number.
            </p>
          </div>
        </div>
        <hr />
        <div class="form-row">
          <div class="col-12 col-md-2">
            <input
              type="checkbox"
              :disabled="school.saving || sftp === null"
              :checked="sftp"
              @change="toggleSftp()"
            />
            <span>
              Sftp
            </span>
          </div>
          <div class="col-12 col-md-5">
            <input-text
              id="folder"
              v-model="folder"
              name="folder"
              label="Sftp Folder"
              type="text"
              :disabled="sftp === true || sftp === null"
            />
          </div>
          <div class="col-12 col-md-5">
            <input-text
              id="publicKey"
              v-model="publicKey"
              name="publicKey"
              label="Sftp Public Key"
              type="text"
              :disabled="sftp === true || sftp === null"
            />
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-wide mt-4"
        >
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';

export default {
  name: 'Integrations',

  components: {
    FormComponent,
    InputText,
  },

  inject:['school'],

  data() {
    return {
      folder: '',
      publicKey: '',
      sftp: null,
      crisisPhone: null,
    }
  },

  async mounted() {
    this.folder = this.school.integrations.sftp.folder;
    this.publicKey = this.school.integrations.sftp.publicKey;
    this.sftp = !!this.school.features.find(x => x === 'sftp');
    this.crisisPhone = !!this.school.features.find(x => x === 'bettermynd-crisis-phone-number');
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        return;
      }

      this.errors.clear();

      try {
        await this.school.updateIntegrations({
          sftp: {
            folder: this.folder,
            publicKey: this.publicKey,
          }
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'Integrations Saved!',
        });
      } catch (ex) {
        console.error(ex)
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save integrations. Please try again!', error: true,
        });
      }
    },
    async toggleSftp() {
      try {
        if (!this.folder || !this.publicKey) {
          this.$store.commit('setGlobalAlert', {
            msg: 'Folder and public key required!',
          });
          return;
        }

        const { sftp } = await this.school.setFeature({ sftp: !this.sftp });
        this.sftp = sftp;
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to set feature state. Please try again!', error: true,
        });
      }
    },
    async toggleCrisisPhone() {
      try {
        await this.school.setFeature({
          'bettermynd-crisis-phone-number': !this.crisisPhone
        });
        this.crisisPhone = !this.crisisPhone;
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to set feature state. Please try again!', error: true,
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label.upper {
  @include label;

  color: $green;
  margin-bottom: 20px;
}
.explainer {
  padding-left: 20px;
  font-style: italic;
}
</style>
